import { ExitGuideButton, PreviousStepButton } from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import {
  advanceToStep,
  setCanAdvance,
  setCurrentProgressTo,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DisplayChartsKeys } from '../../../../../charts/types';
import {
  removeClusters,
  removeMarkers,
  setDisplayCharts,
  setIsActive,
  setIsActiveRightSidebar,
  setIsLoadingMap,
} from '../../../../../redux/dashboardActions';
import { AddAlert } from '../../../../../../../component';
import { postStudyStep } from '../../../../redux/studies.controller';

export const UnderstandMarketCycle: React.FC = () => {
  const displayCharts: DisplayChartsKeys = useTypedSelector(
    (state) => state.dashboardState.displayCharts
  );
  const { bigNumbers } = useTypedSelector((state) => state.bigNumbersState);
  const { id, currentStep } = useTypedSelector(studiesSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch([
      setIsActive({ name: 'menuAction', value: '5' }),
      setIsActiveRightSidebar({ name: 'menuAction', value: '2' }),
      setCurrentProgressTo(6),
      setDisplayCharts(null),
      removeMarkers(),
      removeClusters(),
    ]);
  }, []);
  useEffect(() => {
    if (displayCharts === 'marketCycle') {
      dispatch(setCanAdvance(true));
    }
  }, [displayCharts]);
  const handleClickNextStep = async () => {
    try {
      const payload = {
        primary_market: bigNumbers.primary_percentual_oscillation.value,
        secondary_market: bigNumbers.secondary_percentual_oscillation.value,
        transacioned_market:
          bigNumbers.transactions_percentual_oscillation.value,
      };
      dispatch(setIsLoadingMap(true));
      const response = await postStudyStep(6, id, payload);
      dispatch(AddAlert('success', 'Dados do ciclo de mercado adicionados'));
      dispatch(advanceToStep(currentStep.nextStep));
    } catch (e) {
    } finally {
      dispatch(setIsLoadingMap(false));
    }
  };
  return (
    <>
      <p className="helper-text">
        {nls.studyCreationGuide.steps.step6.helper2}
      </p>
      <div className="study-creation-guide__buttons-container">
        <div>
          <ExitGuideButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <PreviousStepButton />
          <button
            className="btn normal primary"
            data-cy="StudyCreationGuideNextStep"
            onClick={handleClickNextStep}
            disabled={!currentStep.canAdvance}
          >
            {nls.studyCreationGuide.buttons.nextStep}
          </button>
        </div>
      </div>
    </>
  );
};
